import { render, staticRenderFns } from "./MateReturnWrite.vue?vue&type=template&id=c3c78d54&scoped=true"
import script from "./MateReturnWrite.vue?vue&type=script&lang=js"
export * from "./MateReturnWrite.vue?vue&type=script&lang=js"
import style0 from "./MateReturnWrite.vue?vue&type=style&index=0&id=c3c78d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c78d54",
  null
  
)

export default component.exports